import { UserDto, Role, User } from '@treetop/shared/model';

import { mapOrganisationDtoToOrganisation } from '../../../../../share-page/domain/src/lib/infrastructure/organisation.http.service.util';

export const mapUserDtoToUser = (dto: UserDto): User => {
  if (!dto) {
    return undefined;
  }

  return {
    id: dto.id,
    firstName: dto.firstName,
    lastName: dto.lastName,
    email: dto.email,
    currentOrganisation: mapOrganisationDtoToOrganisation(dto.currentOrganisation),
    currentRootOrganisation: mapOrganisationDtoToOrganisation(dto.currentRootOrganisation),
    homeOrganisation: mapOrganisationDtoToOrganisation(dto.homeOrganisation),
    currentRoles: dto.currentRoles as Role[],
    organisationIdsWithEditorPermission: dto.organisationIdsWithEditorPermission,
    organisations: dto.organisations.map(mapOrganisationDtoToOrganisation),
    isTreetopUser: dto.isTreetopUser
  };
};

export const mapUserToDto = (user: User): UserDto => {
  if (!user) {
    return undefined;
  }

  return {
    id: user.id,
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    currentOrganisationId: user.currentOrganisation.id,
    currentOrganisation: user.currentOrganisation,
    currentRootOrganisationId: user.currentRootOrganisation.id,
    currentRootOrganisation: user.currentRootOrganisation,
    homeOrganisationId: user.homeOrganisation.id,
    homeOrganisation: user.homeOrganisation,
    currentRoles: user.currentRoles,
    organisationIdsWithEditorPermission: user.organisationIdsWithEditorPermission,
    isTreetopUser: user.isTreetopUser,
  };
};
